import '../css/preloader.css';
import React from 'react';

const Preloader = () => {

  return (
    <>
      <p className="mt-4 mb-16 text-white">LOADING ...</p>    
      <div id="preloader" className="translate-y-[40px] scale-75">
        <div id="loader"></div>
      </div>
    </>
  );
}

export default Preloader;
